import {VerifyRequiredMeasurementsPipe} from './verify-required-measurements/verify-required-measurements.pipe';
import {ObjectKeyValuePipe} from './object-key-value/object-key-value.pipe';
import {RequiredMeasurementsTranslatePipe} from './required-measurements-translate/required-measurements-translate.pipe';
import {IsAfterDatePipe} from './is-after-date/is-after-date.pipe';
import {GetObjectValuesPipe} from './get-object-values/get-object-values.pipe';
import {GetCountDiseaseParentsPipe} from './get-count-disease-parents/get-count-disease-parents.pipe';
import {GetLevelBiochemicalPipe} from './get-level-biochemical/get-level-biochemical.pipe';
import {StringifyArrayPipe} from './stringify-array/stringify-array.pipe';
import {DefaultOrderKeyValuePipe} from './default-order-key-value/default-order-key-value.pipe';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SliceArrayPipe} from './slice-array/slice-array.pipe';
import {ConcatPropertiesPipe} from './get-name-participants/concat-properties.pipe';
import {FormatDatePipe} from './format-date/format-date.pipe';
import {IsTodayPipe} from './is-today/is-today.pipe';
import {GetDatePipe} from './get-date/get-date.pipe';
import {CompareDatesPipe} from './compare-dates/compare-dates.pipe';
import {GetAgePipe} from './get-age/get-age.pipe';
import {GetTranslateEnumPipe} from './get-translate-enum/get-translate-enum.pipe';
import {GetPhoneStructurePipe} from './get-phone-structure/get-phone-structure.pipe';
import {GetTypeAppointmentPipe} from './get-type-appointment/get-type-appointment.pipe';
import {GetDateFromSystemPipe} from './get-date-from-system/get-date-from-system.pipe';
import {GetDifferentInCalendarDaysPipe} from './get-different-in-calendar-days/get-different-in-calendar-days.pipe';
import {FilterAppointmentByDayPipe} from './filter-appointment-by-day/filter-appointment-by-day.pipe';
import {FilterAppointmentsPipe} from './filter-appointments/filter-appointments.pipe';
import {OrderArrayByPipe} from './order-array-by/order-array-by.pipe';
import {SetClinicalObjectiveColorPipe} from './set-clinical-objective-color/set-clinical-objective-color.pipe';
import {GetNotesByUserPipe} from './get-notes-by-user/get-notes-by-user.pipe';
import {GetNameDayPipe} from './get-name-day/get-name-day.pipe';
import {GetTimtableByDayPipe} from './get-timetable-by-day/get-timtable-by-day.pipe';
import {ConvertHourTablePipe} from './convert-hour-table/convert-hour-table.pipe';
import {ConvertStringDatePipe} from './convert-string-date/convert-string-date.pipe';
import {SanitizerHtmlPipe} from './sanitizer-html/sanitizer-html.pipe';
import {GetPredominantImageColorPipe} from './get-predominant-image-color/get-predominant-image-color.pipe';
import {SetAppointmentStatusColorPipe} from './set-appointment-status-color/set-appointment-status-color.pipe';
import {FilterMeasurementUnitsPipe} from './filter-measurement-units/filter-measurement-units.pipe';
import {SetColorByIndexPipe} from './set-color-by-index/set-color-by-index.pipe';
import {FilterArrayPipe} from './filter-array/filter-array.pipe';
import {GetStatementStatusPipe} from './get-statement-status/get-statement-status.pipe';
import {GetSleepStatusPipe} from './get-sleep-status/get-sleep-status.pipe';
import {GetImcGradePipe} from './get-imc-grade/get-imc-grade.pipe';
import {GetDaysEnrichingActivitiesPipe} from './get-days-enriching-activities/get-days-enriching-activities.pipe';
import {GetImagePipe} from './get-image/get-image.pipe';
import {ItsNewTemplatePipe} from './its-new-template/its-new-template.pipe';
import {GetFormGroupPipe} from './get-form-group/get-form-group.pipe';
import {CalSmaeGramsPipe} from './calc-smae-grams/cal-smae-grams.pipe';
import {CalSmaeResultPipe} from './calc-smae-result/cal-smae-result.pipe';
import {HasAnyAllergicIngredientPipe} from './has-any-allergic-ingredient/has-any-allergic-ingredient.pipe';
import {HasAnyDislikeIngredientPipe} from './has-any-dislike-ingredient/has-any-dislike-ingredient.pipe';

const pipes = [
  SliceArrayPipe,
  ConcatPropertiesPipe,
  FormatDatePipe,
  IsTodayPipe,
  GetDatePipe,
  CompareDatesPipe,
  GetAgePipe,
  GetTranslateEnumPipe,
  GetPhoneStructurePipe,
  GetTypeAppointmentPipe,
  GetDateFromSystemPipe,
  GetDifferentInCalendarDaysPipe,
  FilterAppointmentByDayPipe,
  FilterAppointmentsPipe,
  OrderArrayByPipe,
  SetClinicalObjectiveColorPipe,
  GetNotesByUserPipe,
  GetNameDayPipe,
  GetTimtableByDayPipe,
  ConvertHourTablePipe,
  ConvertStringDatePipe,
  SanitizerHtmlPipe,
  GetPredominantImageColorPipe,
  SetAppointmentStatusColorPipe,
  FilterMeasurementUnitsPipe,
  SetColorByIndexPipe,
  FilterArrayPipe,
  DefaultOrderKeyValuePipe,
  GetStatementStatusPipe,
  StringifyArrayPipe,
  GetSleepStatusPipe,
  GetImcGradePipe,
  GetLevelBiochemicalPipe,
  GetCountDiseaseParentsPipe,
  GetObjectValuesPipe,
  IsAfterDatePipe,
  GetDaysEnrichingActivitiesPipe,
  GetImagePipe,
  ItsNewTemplatePipe,
  RequiredMeasurementsTranslatePipe,
  ObjectKeyValuePipe,
  VerifyRequiredMeasurementsPipe,
  GetFormGroupPipe,
  CalSmaeGramsPipe,
  CalSmaeResultPipe,
  HasAnyAllergicIngredientPipe,
  HasAnyDislikeIngredientPipe
];

@NgModule({
  declarations: pipes,
  imports: [
    CommonModule
  ],
  exports: pipes
})
export class PipesModule { }
